export default __webpack_public_path__ + "static/media/Click2.e1ea46b8.mp3";